/*
 * @Author: Teemo Ding
 * @Date: 2021-04-21 10:40:58
 * @LastEditTime: 2023-03-30 10:45:36
 * @LastEditors: Json Chen
 * @Description: Preview
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/Preview/index.tsx
 */

import { getI18nFromGeneral } from '@/src/tools/tools';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { withDraggableId } from 'src/constrains/Preview/util';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  ProductDetailCarousel,
  ProductInformation,
} from 'unifyxp-ecomm-components';
import { EnumCollapseId } from '../common';
import { getContent, getThumbnailImage, onCollapseOpen } from '../slice';
import styles from './style.module.less';
const Preview = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const productContent = useSelector(getContent('contentDetails'));
  const productCarousel = useSelector(getContent('carousel'));
  const original = useSelector(getContent('original'));
  const thumbnailImage = useSelector(getThumbnailImage());
  const linkModules = (thumbnailImage || {}).linkModules || [];

  const {
    productName,
    productSubtitle,
    contentPrice = [],
    currency,
    productDescription,
  } = productContent;
  const { staticData, sameAsOriginal } = productCarousel;
  const dynamicData =
    (sameAsOriginal
      ? original?.carousel?.dynamicData
      : productCarousel?.dynamicData) || [];

  const { autoPlay, intervalTime } = staticData || {};
  const thumbnailImageImageList = linkModules.map((item) => ({
    url: (item.linkImage || {}).url,
    quantity: item.title || '',
  }));

  const contentPriceCopy = _.cloneDeep(contentPrice);
  contentPriceCopy.sort();
  const product = {
    title: productName,
    subTitle: productSubtitle,
    isSoldOut: false,
    lp:
      contentPriceCopy && contentPriceCopy.length > 1
        ? `${currency} ${contentPriceCopy[0]} - ${
            contentPriceCopy[contentPriceCopy.length - 1]
          }`
        : `${currency || ''} ${contentPriceCopy[0] || ''}`,
    skuData:
      thumbnailImageImageList.length > 1
        ? {
            title: getI18n(
              'salesChannelProductAlias.editPage.pleaseselectcategory',
            ),
            skus: thumbnailImageImageList || [],
          }
        : null,
  };

  const _ProductDetailCarousel = withDraggableId(
    ProductDetailCarousel,
    EnumCollapseId.carousel,
    onCollapseOpen,
  );
  const _ProductInformation = withDraggableId(
    ProductInformation,
    EnumCollapseId.contentDetails,
    onCollapseOpen,
  );
  const dynamicDataSort = dynamicData.reduce((acc, item) => {
    if (item.coverImage === true) {
      acc.unshift(item);
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
  const carouselImageList = (dynamicDataSort || [])
    .map((item) => ((item.linkModule || {}).linkImage || {}).url)
    .concat((thumbnailImageImageList || []).map((item) => (item || {}).url));

  return (
    <div className={styles.container}>
      <_ProductDetailCarousel
        data={carouselImageList}
        autoPlay={autoPlay}
        interval={intervalTime * 1000}
      />
      <div className={styles.informationContainer}>
        <_ProductInformation
          product={product}
          style={{ background: '#ffffff' }}
        />
      </div>
      {productDescription && (
        <div className={styles.productDescription}>
          <h3 className={styles.productDescriptionTitle}>
            {getI18nFromGeneral('general.hOCTitle.productDetails')}
          </h3>
          <p>{productDescription}</p>
        </div>
      )}
    </div>
  );
};

export default Preview;
